import React from 'react'
import { Switch, Route } from "react-router-dom"
import SettingsMenu from './settings-menu.component'
import Profile from './profile/profile.component'
import ChangePassword from './change-password/change-password.component'

const SettingsController = () => {
    return (
        <div className="settings">
            <Switch>
                <Route path="/settings/change-password" component={ChangePassword} />
                <Route path="/settings/profile" component={Profile} />
                <Route exact path="/settings" component={SettingsMenu} />
            </Switch>
        </div>
    )
}

export default SettingsController